import { Partial } from '@40seas/entities/common';
import { CreateFinancialConnectionRefreshRequestDto } from './create.financial-connection-refresh-request.dto';

export class UpdateFinancialConnectionRefreshRequestDto extends Partial(CreateFinancialConnectionRefreshRequestDto) {}
